import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenece la pantalla (encabezado de la bandeja). */
const SECCION = 'Ixodicida (IXO)';

/**
 * Sección de Ixodología. Hoy trabaja un solo servicio del RT-52 —la evaluación
 * biológica de ixodicida (IHIMV-RT-21 IXOD)—, el único formato del sistema que
 * informa un producto y no un animal.
 */
export const ixodologiaRoutes: Routes = [
  {
    path: 'ixodologia/evaluacion-ixodicida',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Evaluación de ixodicida',
    data: {
      pantalla: 'IXODICIDA',
      breadcrumb: SECCION,
      titulo: 'Evaluación biológica de ixodicida',
      permiso: Permiso.IXODICIDA_VER,
    },
  },
  {
    path: 'ixodologia/evaluacion-ixodicida/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'IXODICIDA',
      permiso: [Permiso.IXODICIDA_RESULTADOS, Permiso.IXODICIDA_VER],
    },
    loadComponent: () =>
      import('./pages/ixodicida-resultados/ixodicida-resultados.page').then(
        (m) => m.IxodicidaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Ixodicida',
  },
];
